var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfoMarketPlace = function SvgIconInfoMarketPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.263 14.943a6.714 6.714 0 0 0 5.825-1.173 6.72 6.72 0 0 0 2.579-5.27 6.73 6.73 0 0 0-3.689-5.97 6.66 6.66 0 0 0-2.964-.694A6.7 6.7 0 0 0 3.91 3.23a6.72 6.72 0 0 0-2.438 6.642 6.72 6.72 0 0 0 4.79 5.071M4.539 4.04a5.68 5.68 0 0 1 3.475-1.178c.874 0 1.74.203 2.506.586A5.69 5.69 0 0 1 13.64 8.5c0 1.73-.816 3.397-2.182 4.46a5.7 5.7 0 0 1-3.477 1.183 5.6 5.6 0 0 1-1.453-.191 5.68 5.68 0 0 1-4.052-4.29A5.69 5.69 0 0 1 4.539 4.04M8 6.217a.5.5 0 0 1-.362-.151.505.505 0 0 1 0-.724.53.53 0 0 1 .723-.002.515.515 0 0 1-.361.877m0 5.593a.513.513 0 0 1-.513-.514V7.243a.513.513 0 0 1 1.026 0v4.053c0 .284-.23.514-.513.514",
    clipRule: "evenodd"
  })));
};
export default SvgIconInfoMarketPlace;